(function() {
  angular.module('providerPortal')
  .controller('navController', ['historyService', '$http', 'secSecurityService', '$rootScope',
    function (historyService, $http, securityService, $rootScope) {
      var vm = this;
      vm.isNavCollapsed = true;
    }
  ]);
})();
